import React, { useState } from "react";

// Available fixed sizes offered by the flagcdn.com API (all 4:3 ratio),
// keyed by the "WIDTHxHEIGHT" string used as the `size` prop.
// See https://flagpedia.net/download/api
export const FLAG_SIZES = {
  "16x12": { width: 16, height: 12 },
  "20x15": { width: 20, height: 15 },
  "24x18": { width: 24, height: 18 },
  "28x21": { width: 28, height: 21 },
  "32x24": { width: 32, height: 24 },
  "36x27": { width: 36, height: 27 },
  "40x30": { width: 40, height: 30 },
  "48x36": { width: 48, height: 36 },
  "56x42": { width: 56, height: 42 },
  "60x45": { width: 60, height: 45 },
  "64x48": { width: 64, height: 48 },
  "72x54": { width: 72, height: 54 },
  "80x60": { width: 80, height: 60 },
  "84x63": { width: 84, height: 63 },
  "96x72": { width: 96, height: 72 },
  "108x81": { width: 108, height: 81 },
  "112x84": { width: 112, height: 84 },
  "120x90": { width: 120, height: 90 },
  "128x96": { width: 128, height: 96 },
  "144x108": { width: 144, height: 108 },
  "160x120": { width: 160, height: 120 },
  "192x144": { width: 192, height: 144 },
  "224x168": { width: 224, height: 168 },
  "256x192": { width: 256, height: 192 },
};

const DEFAULT_SIZE = "16x12";

const flagUrl = (country, size) => `https://flagcdn.com/${size}/${country}.png`;

// Build the srcSet, only including a retina multiplier when the exact
// multiplied size is actually offered by the API (e.g. 224x168 has no 2x).
const buildSrcSet = (country, { width, height }) =>
  [2, 3]
    .map((factor) => [factor, `${width * factor}x${height * factor}`])
    .filter(([, size]) => FLAG_SIZES[size])
    .map(([factor, size]) => `${flagUrl(country, size)} ${factor}x`)
    .join(", ");

const CountryFlag = ({ country, size = DEFAULT_SIZE, className }) => {
  // Track the specific URL that failed rather than a boolean, so that when the
  // props change to a new URL the error state clears automatically and we retry.
  const [erroredSrc, setErroredSrc] = useState(null);

  const dimensions = FLAG_SIZES[size];

  if (!dimensions) return null;

  const src = flagUrl(country, size);

  // Return null to show nothing while this exact URL is known to be broken.
  if (erroredSrc === src) return null;

  const srcSet = buildSrcSet(country, dimensions);

  return (
    <img
      className={className}
      src={src}
      srcSet={srcSet || undefined}
      width={dimensions.width}
      height={dimensions.height}
      alt={`${country} flag`}
      onError={() => setErroredSrc(src)}
      onLoad={() => setErroredSrc(null)}
    />
  );
};

export default CountryFlag;
